import { defineMessages, IntlShape } from 'react-intl';
import { ButtonSchema } from '@fhnw/schemas/button';

const messages = defineMessages({
  Buttons: {
    id: 'label_buttons',
    defaultMessage: 'Buttons',
  },
});

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Buttons),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['items'],
    },
  ],

  properties: {
    items: {
      title: intl.formatMessage(messages.Buttons),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: ButtonSchema({ intl: intl }),
          },
        },
      },
    },
  },
  required: [],
});

export default Schema;
